import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AthleteDashboard() {
  const { user } = useAuth();
  const [data, setData] = useState({ tournaments: [], attendance: [], competitions: [], feedback: [], plan: null });
  useEffect(() => {
    Promise.all([api.get("/tournaments"), api.get("/attendance"), api.get("/competitions"), api.get("/feedback"), api.get("/my-plan")])
      .then(([tournaments, attendance, competitions, feedback, plan]) => setData({ tournaments: tournaments.data, attendance: attendance.data, competitions: competitions.data, feedback: feedback.data, plan: plan.data }))
      .catch(() => {});
  }, []);
  const present = data.attendance.filter((item) => item.status === "Presente").length;
  const frequency = data.attendance.length ? Math.round((present / data.attendance.length) * 100) : 0;
  return <AppLayout kind="athlete">
    <p className="text-amber-300 text-xs uppercase tracking-widest">Painel do Atleta</p>
    <h1 className="text-3xl sm:text-4xl text-white font-semibold mt-1 mb-8">Olá, {user?.name?.split(" ")[0]}</h1>
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
      <Card className="bg-transparent gsx-card-dark p-5"><div className="text-xs text-slate-400 uppercase">Frequência</div><div className="text-2xl text-white mt-2">{frequency}%</div><div className="text-xs text-slate-400">{present}/{data.attendance.length} treinos</div></Card>
      <Card className="bg-transparent gsx-card-dark p-5"><div className="text-xs text-slate-400 uppercase">Competições</div><div className="text-2xl text-white mt-2">{data.competitions.length}</div></Card>
      <Card className="bg-transparent gsx-card-dark p-5"><div className="text-xs text-slate-400 uppercase">Plano de Treinamento</div><div className="text-2xl text-white mt-2">{data.plan?.available ? "Disponível" : "Pendente"}</div></Card>
    </div>
  </AppLayout>;
}
